import { createSelector } from 'reselect';
import { HeadSlice } from './types';
import { reduxKey } from './constants';

function getSlice(state: any): HeadSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getCurrentHeadState = createSelector(getSlice, slice => {
  return slice.headState;
});

export const getHeadLinks = createSelector(getCurrentHeadState, state => {
  return state?.link;
});

export const getHeadMeta = createSelector(getCurrentHeadState, state => {
  return state?.meta;
});

export const getHeadScript = createSelector(getCurrentHeadState, state => {
  return state?.script;
});

export const getHeadStyle = createSelector(getCurrentHeadState, state => {
  return state?.style;
});

export const getTitle = createSelector(getCurrentHeadState, state => {
  return state?.title;
});

export const getLang = createSelector(getCurrentHeadState, state => {
  return state?.lang;
});
